var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcceptedOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2749",
    "data-name": "Group 2749",
    transform: "translate(-320 -309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(320 309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    fill: "none",
    stroke: "#60c916",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "tick",
    transform: "translate(325.18 315.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2747",
    "data-name": "Group 2747",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3363",
    "data-name": "Path 3363",
    d: "M10.04,68.147a.509.509,0,0,0-.721,0l-6.1,6.1L.869,71.9a.509.509,0,0,0-.721.72l2.706,2.706a.51.51,0,0,0,.721,0l6.464-6.464A.509.509,0,0,0,10.04,68.147Z",
    transform: "translate(0 -67.997)",
    fill: "#60c916"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptedOrder);
export default __webpack_public_path__ + "static/media/accepted-order.b5439e580520c552ebd8fd2642206c7b.svg";
export { ForwardRef as ReactComponent };